import React from "react";
import Flink from '~/components/shared/flink'
import useTestFunnelHook from '~/utils/test-funnel'
import useAnalytics from '~/utils/analytics'
import { notBlank } from '~/utils/helpers'

import ImgGrid from '~/components/shared/img-grid'

import * as styles from "~/styles/tiles/tile.module.scss"
import * as cstyle from "~/styles/shared/callouts.module.scss"

const TileVintage = ({ product, tile_ind, isInView, flats, parStyles='' }) => {
  const { elev_select, ga_tile_click, ga_tile_interact } = useAnalytics()
  const { fnnl_tile } = useTestFunnelHook()

  const { handle, title, media } = product
  
  const fprice = (fpp, ffp) => {
    return ffp > fpp ? ffp : fpp
  }

  const handleSelect = () => {
    ga_tile_click(product, tile_ind)
    elev_select(product, tile_ind)
    fnnl_tile()
  }

  const handleInteract = (action) => {
    ga_tile_interact(product, action)

    if (action === 'tile click: swatch' || action === 'tile click: more colors') {
      ga_tile_interact(product, 'tile click: quick pdp')
      fnnl_tile()
    }
  }

  const price = fprice(product.first_product_price, product.first_full_price)
  const sold = price === 0 || !product.available

  return (
    <>
      <div className={styles.images}>
        {(isInView && media && media.length > 0) && (
          <ImgGrid 
            media={media} 
            handle={handle} 
            title={title} 
            wr_class={'tile_link'} 
            linked={true} 
            tile_ind={tile_ind} 
            toggleFlats={flats} 
            onHandleSelect={handleSelect}
            gaInteract={handleInteract}
          />
        )}
      </div>
      <div className={styles.infos} tile-infos="">
        <div className={styles.info}>
          <Flink 
            href={`/products/${handle}`} 
            className={[styles.tile_link, styles.tile_title].join(' ')} 
            tile-title=""
            onClick={(e)=> handleSelect()}
          >
            {title}
          </Flink>
          <div data-product-price="" className={styles.price} tile-price="">
            {sold ? (
              <span className={styles.vsold}>
                SOLD
              </span>
            ) : (
              <span>${price}</span>
            )}
          </div>
        </div>
        
        {(notBlank(product.year) || (product.hasOwnProperty('size') && notBlank(product.size)) ) && (
          <div className={[styles.info, styles.vinfos].join(' ')}>
            {(product.hasOwnProperty('size') && notBlank(product.size)) && (
              <>
                <div className={styles.vinfo_label}>
                  Size
                </div>
                <div className={styles.vinfo_data}>
                  {product.size}
                </div>
              </>
            )}
            {notBlank(product.year) && (
              <>
                <div className={styles.vinfo_label}>
                  Year
                </div>
                <div className={styles.vinfo_data}>
                  {product.year}
                </div>
              </>
            )}
          </div>
        )}

        <div className={styles.info} tile-calls="" style={{fontSize: 'inherit'}}> 
          <div className={[styles.info, styles.callouts, cstyle.callouts].join(' ')}>
            <span className={[cstyle.callout, styles.callout].join(' ')} style={{color: '#666'}}>
              Vintage
            </span>
          </div>
        </div>
      </div>
    </>
  )
}

export default TileVintage

